import { GroupData } from '@/components/planning/modal/GroupModal';
import { PlanningGroup, PlanningLineItem } from '@/services/PlanningService';

export const areNumberSetsEqual = (left: Set<number>, right: Set<number>): boolean => {
  if (left.size !== right.size) return false;
  return Array.from(left).every(value => right.has(value));
};

export const truncateText = (text: string, maxLength = 30): string =>
  text.length <= maxLength ? text : `${text.substring(0, maxLength)}...`;

export const getVisibleLineItemIds = (groups: PlanningGroup[]): number[] =>
  groups.flatMap(group => (group.lineItems ?? []).map(lineItem => lineItem.id));

export const getSelectedVisibleLineItemCount = (
  visibleLineItemIds: number[],
  selectedLineItems: Set<number>,
): number => visibleLineItemIds.filter(id => selectedLineItems.has(id)).length;

export const mapPlanningGroupsToGroupData = (groups: PlanningGroup[]): GroupData[] =>
  groups.map(group => ({
    id: group.id,
    identifier: group.groupIdentifier,
    title: group.title,
  }));

export const mapPlanningGroupsToAvailableGroups = (groups: PlanningGroup[]): PlanningGroup[] =>
  groups.map(group => ({
    id: group.id,
    groupIdentifier: group.groupIdentifier,
    title: group.title,
  }));

export const findPlanningGroupIdForLineItem = (
  groups: PlanningGroup[],
  lineItemId: number,
): number | null => {
  const group = groups.find(candidate => candidate.lineItems?.some(lineItem => lineItem.id === lineItemId));
  return group?.id ?? null;
};

export const mergePlanningLineItems = (
  existingLineItems: PlanningLineItem[],
  refreshedLineItems: PlanningLineItem[],
): PlanningLineItem[] => {
  const existingById = new Map(existingLineItems.map(lineItem => [lineItem.id, lineItem]));
  return refreshedLineItems.map(lineItem => ({
    ...existingById.get(lineItem.id),
    ...lineItem,
  }));
};
